// extracted by mini-css-extract-plugin
export default {"container":"SpinnerWithHeight_container__38gSz"};